module.exports = __webpack_public_path__ + "media/icons/section_b@2x-18bbbc24.png";